import React from "react";
import { motion } from "framer-motion";
import {
  RiHeart3Line,
  RiHeart3Fill,
  RiChat3Line,
  RiShareForwardLine,
  RiBookmarkLine,
  RiBookmarkFill,
} from "react-icons/ri";
import { formatNumber } from "../../utils/helpers";

const PostEngagementBar = ({
  likeCount,
  commentCount,
  shareCount,
  isLiked,
  isSaved,
  onLike,
  onComment,
  onShare,
  onSave,
}) => (
  <div className="wpc-engagement">
    <div className="wpc-engagement-actions">
      <motion.button
        type="button"
        className={`wpc-action ${isLiked ? "wpc-action--liked" : ""}`}
        onClick={onLike}
        whileTap={{ scale: 1.3 }}
        aria-pressed={isLiked}
        aria-label={isLiked ? "Unlike workout" : "Like workout"}
      >
        {isLiked ? <RiHeart3Fill size={20} /> : <RiHeart3Line size={20} />}
      </motion.button>
      <button
        type="button"
        className="wpc-action"
        onClick={onComment}
        aria-label="View comments"
      >
        <RiChat3Line size={20} />
      </button>
      <button
        type="button"
        className="wpc-action"
        onClick={onShare}
        aria-label="Share workout"
      >
        <RiShareForwardLine size={20} />
      </button>
      <motion.button
        type="button"
        className={`wpc-action wpc-action--save ${isSaved ? "wpc-action--saved" : ""}`}
        onClick={onSave}
        whileTap={{ scale: 1.2 }}
        aria-pressed={isSaved}
        aria-label={isSaved ? "Unsave workout" : "Save workout"}
      >
        {isSaved ? <RiBookmarkFill size={20} /> : <RiBookmarkLine size={20} />}
      </motion.button>
    </div>
    <div className="wpc-engagement-counts">
      <span>{formatNumber(likeCount)} Likes</span>
      <span>{formatNumber(commentCount)} Comments</span>
      <span>{formatNumber(shareCount)} Shares</span>
    </div>
  </div>
);

export default PostEngagementBar;
